export const GOOGLE = {
	MAPS_API_KEY: process.env.GOOGLE_MAPS_API_KEY!,
	ACTION_CENTER: {
		PARTNER_ID: process.env.GOOGLE_ACTION_CENTER_PARTNER_ID!,
		SERVICE_ACCOUNT: {
			CLIENT_EMAIL: process.env.GOOGLE_ACTION_CENTER_SERVICE_ACCOUNT_CLIENT_EMAIL!,
			PRIVATE_KEY: process.env.GOOGLE_ACTION_CENTER_SERVICE_ACCOUNT_PRIVATE_KEY!,
		},
		BOOKING_SERVER: {
			USERNAME: process.env.GOOGLE_ACTION_CENTER_BOOKING_SERVER_USERNAME!,
			PASSWORD: process.env.GOOGLE_ACTION_CENTER_BOOKING_SERVER_PASSWORD!,
		},
		FEEDS: {
			SFTP_KEY: process.env.GOOGLE_ACTION_CENTER_FEEDS_SFTP_KEY!,
			URL: process.env.GOOGLE_ACTION_CENTER_FEEDS_URL!,
			PORT: Number(process.env.GOOGLE_ACTION_CENTER_FEEDS_PORT!),
			USERNAMES: {
				MERCHANTS: process.env.GOOGLE_ACTION_CENTER_FEEDS_USERNAMES_MERCHANTS!,
				SERVICES: process.env.GOOGLE_ACTION_CENTER_FEEDS_USERNAMES_SERVICES!,
				AVAILABILITY: process.env.GOOGLE_ACTION_CENTER_FEEDS_USERNAMES_AVAILABILITY!,
			},
			UPLOAD_SCHEDULE: process.env.GOOGLE_ACTION_CENTER_FEEDS_UPLOAD_SCHEDULE!,
			/** Google Availability Feed Window in weeks */
			AVAILABILITY_FEED_WINDOW: Number(process.env.GOOGLE_AVAILABILITY_FEED_WINDOW! ?? 6),
		},
	},
}
